module.exports = __webpack_public_path__ + "static/media/abeja.cc98eb58.png";